<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-出库-修改
    -->
    <el-dialog
    title="修改出库"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="70%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <!-- <div class="common-form">基本信息</div>
      <el-form-item label="出库类型：" >
            <span v-if="form.order_id > 0">
              线上销售出库

              </span>
              <span v-else>
                <el-radio-group v-model="form.type">
                <el-radio :label="0">线下出库</el-radio>
        
              </el-radio-group>
              </span>  
        
  
        </el-form-item> -->


        <!-- <div class="common-form">选择批次</div> -->
        
        

        <div class="common-form">出库清单</div>   
        <el-button icon="el-icon-plus"  @click="changeProduct(form.product)">选择商品</el-button>
        <el-table size="small" :data="form.product"   border style="width: 100%" v-loading="loading">
          <!-- <el-table-column prop="batchNumber" label="批次"></el-table-column> -->
          
          <el-table-column prop="product_name" label="商品"></el-table-column>
          <el-table-column prop="spec_value" label="规格"></el-table-column>
          <el-table-column prop="unit" label="计量单位"></el-table-column>
          <el-table-column prop="act_stock" label="实际库存"></el-table-column>
          <el-table-column prop="set_num" label="数量">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.set_num"
                @input="updateAmount(scope.row)"
                placeholder="请输入数量"
                type="number"
              ></el-input>

        

            </template>

          </el-table-column>
          <el-table-column prop="product_price" label="单价">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.product_price"
                @input="updateAmount(scope.row)"
                placeholder="请输入单价"
                type="number"
              ></el-input>
         
            </template>

          </el-table-column>
          <el-table-column prop="amount" label="金额"></el-table-column>
          <el-table-column prop="act_price" label="实际支付"></el-table-column>
          <el-table-column prop="warehousekwtext" label="库区"></el-table-column>
          <el-table-column prop="rk.rk_text" label="入库状态">
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button @click="del(scope.$index)" size="mini">删除</el-button>
            </template>
          </el-table-column>


          <!-- 自定义插入一行 -->
          <template v-slot:append  v-if="form.product">
            
            <div style="float: right;">
              <tr class="custom-footer" style="border: 1px solid red;height: 50px;">
              <!-- 合并列 --> 
             
          
                <td style="font-size: 20px;width: 100px;float: right;line-height: 50px; text-align: center; background-color: #f5f5f5;">
                  {{ form.totalAmount }}
                </td>
                <td  style="font-size: 20px; width: 100px;float: right;line-height: 50px; text-align: center; font-weight: bold; background-color: #f5f5f5;">
                  总计
                </td>
              <div style="clear: both;"></div>
            </tr>
            </div>
            
       
          </template>
        </el-table>
    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
    <!-- <Categoryas :isproduct="iscategorya" :excludeIds="excludeIds" :islist="false" @closeDialog="closeDialogFunc"></Categoryas> -->
  </div>
  <Batch :isBatch="isBatch" :excludeIds="excludeIds" :choose_supply_id='form.supply_id'  :islist="islist" @closeDialog="closeDialogFuncBatch"></Batch>
</el-dialog>
  
</template>

<script>
import Out_managementApi from '@/api/out_management.js';
import Upload from '@/components/file/Upload';
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
import Batch from '@/components/product/batch';
import {mergeTable} from '@/utils/table.js'
export default {
  components: {
     /*图片上传*/
     Upload: Upload,
     Categoryas,
     draggable,
     Uediter,
     Batch
  },
  data() {
    return {
      isproduct: false,
      /*产品去重*/
      excludeIds: [],
      islist:true,
          /*是否上传图片*/
          isupload: false,
      isImg: false,  
          /*富文本配置*/
          ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        amount:0,
        type:0,
        product:[],
        totalAmount:0,
      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入出库名称', trigger: 'blur' }],
      },
      dialogVisible:false,
      iscategorya:false,
      excludeIds:[],
      isProductUpload:false,
      code:"album",
      isBatch:false,
      choose_supply_id:0,
      isuse:0,
    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
    this.getDetail();
    
    var self = this;
    self.getInas({},function(res){
      console.log(res)
      self.isuse = res
    })
    
  },
  props: ["open_add","out_management_id"],
  methods: {
    // 更新金额（当修改单价时）
    updateAmount(row) {
      row.amount = (parseFloat(row.product_price) * parseFloat(row.set_num)).toFixed(2);
      this.updateTotalAmount();  // 更新总金额
    },
     // 更新总金额
     updateTotalAmount() {
      this.form.totalAmount = this.form.product.reduce((acc, row) => parseFloat(acc) + parseFloat(row.amount), 0);
      this.$forceUpdate()
    },
    del(index){
      this.form.product.splice(index,1)
    },
    closeDialogFuncBatch(e){
      console.log('e.params',e.params)
      let self = this;
      self.isBatch = false;
      if (e.type === 'success') {
        let arr = [];
        for (let i = 0; i < e.params.length; i++) {
          let item = e.params[i];
          let obj = {
            product_name: item.product_name,
            product_id: item.product_id,
            product_sku_id: item.product_sku_id,
            product_price: item.product_price,
            product_image: item.image.file_path?item.image.file_path:item.product_image,
            warehouse_kw_id: item.warehouse_kw_id,
            warehousekwtext: item.warehousekwtext,
            warehousetext: item.warehousetext,
            unit: item.unit,
            spec_value:item.spec_value,
            status:0,//0 未入库 1  已入库
            set_num:1,
            file_path:item.image.file_path,
            rk:item.warehouse_management,
            category_name:item.category_name,
            batchNumber:item.batchNumber,
            act_stock:item.act_stock,
          };
          arr.push(obj)
        }
        self.form.product = self.form.product.concat(arr);
        self.form.product = mergeTable(this.form.product);
        for(var i=0;i<self.form.product.length;i++){
          self.updateAmount(self.form.product [i]);
        }
    }
  },
    /*关闭弹窗*/
    closeDialogFunc(e) {
      console.log('e.params',e.params)
      let self = this;
      self.isproduct = false;
      if (e.type === 'success') {
        let arr = [];
        for (let i = 0; i < e.params.length; i++) {
          let item = e.params[i];
          let obj = {
            product_name: item.product_name,
            product_id: item.product_id,
            product_sku_id: item.product_sku_id,
            product_price: item.product_price,
            product_image: item.product_image,
            warehouse_kw_id: item.warehouse_kw_id,
            warehousekwtext: item.warehousekwtext,
            warehousetext: item.warehousetext,
            unit: item.unit,
            spec_value:item.spec_value,
            status:0,//0 未入库 1  已入库
            set_num:1,
            file_path:item.image.file_path,
            rk:item.warehouse_management,
            category_name:item.category_name,
          };
          arr.push(obj)
        }
        self.form.product = self.form.product.concat(arr);
        self.form.product = mergeTable(this.form.product);
        for(var i=0;i<arr.length;i++){
          self.updateAmount(arr[i]);
        }
      
      }
    },
    /*打开添加*/
    changeProduct(list) {
      let arr = [];
      list.forEach(item => {
        arr.push(item.product_sku_id);
      });
      this.excludeIds = arr;
      this.isBatch = true;
    },


 
     /*获取图片*/
     returnImgsFunc(e) {
      let self = this;
      if (e != null) {
        this.form.image_id = e[0].file_id;
          this.form.image = e[0].file_path;
          this.isImg = true;
        
      }
      this.isupload = false;
    },
     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", {});
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },
    getDetail() {
      let self = this;
      // 取到路由带过来的参数
      Out_managementApi.detail({out_management_id: self.out_management_id},true).then(res => {
          self.form = res.data;
          self.loading = false;
      
        })
        .catch(error => {});
    },
    onSubmit() {
      let self = this;
      let form = self.form;
      form.out_management_id = self.out_management_id
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Out_managementApi.edit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消修改，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },

  
    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if(this.code == 'album'){
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.image.concat(e);
        this.$set(this.form, "image", imgs);
      }
      }else{
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.bannar.concat(e);
        this.$set(this.form, "bannar", imgs);
      }
      }
      
      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index,code) {
      if(code == 'album'){
        this.form.image.splice(index, 1);
      }else if(code == 'bannar'){
        this.form.bannar.splice(index, 1);
      }
      
    },
  }
};
</script>

<style>
.process-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

.button-container {
  margin-top: 20px;
  text-align: center;
}
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}



.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/out_management/index/part/edit.vue